import * as React from 'react';
import { CoreDropdown } from '../internal/WixUiCoreComponents/components/CoreDropdown';
import { DropdownOption } from '../Dropdown/DropdownOption';
import { useTPAComponentsContext } from '../TPAComponentsConfig';
import { st, classes } from './FloatingDropdown.st.css';
import { FloatingDropdownBase } from './FloatingDropdownBase';
import { DATA_HOOKS } from './constants';
import { OptionFactory, } from '../internal/WixUiCoreComponents/components/CoreDropdownOption';
import { createOptionId, modifyOptions } from '../Dropdown/helpers';
import uniqueId from '../../common/uniqueId';
import classnames from 'classnames';
import { deprecationLog } from '../../common/deprecationLog';
import { useComboboxPatternKeys } from '../Dropdown/useComboboxPatternKeys';
/* TODO
 * The import below is a workaround. FloatingDropdown and Dropdown
 * components should be refactored according to this thread
 * https://github.com/wix/wix-ui-tpa/pull/387 (or merged into a single component)
 */
import { classes as dropdownClasses } from '../Dropdown/Dropdown.st.css';
/** Dropdown component for sort. */
export const FloatingDropdown = (props) => {
    const rootRef = React.useRef();
    const { removeElementMinWidth, onChange, options } = props;
    const { mobile } = useTPAComponentsContext();
    const containerId = uniqueId('floating-dropdown-options-container_');
    const [isExpanded, setIsExpanded] = React.useState(false);
    const [focusedOptionId, setFocusedOptionId] = React.useState(null);
    React.useEffect(() => {
        if (!removeElementMinWidth) {
            deprecationLog('FloatingDropdown', 'The current `FloatingDropdown` component API will be deprecated in a future version. Please use the `removeElementMinWidth` prop in order to use the new API.');
        }
    }, []);
    const onSelect = (id) => {
        if (onChange) {
            const newSelectedOption = options.find((option) => option.id === id);
            if (newSelectedOption) {
                onChange(newSelectedOption);
                close();
            }
        }
    };
    const onCoreSelect = (selectedCoreOption) => {
        if (!selectedCoreOption) {
            return;
        }
        onSelect(String(selectedCoreOption.id));
    };
    const coreOptions = options.map((option) => option.divider
        ? OptionFactory.createDivider({ className: classes.optionDivider })
        : OptionFactory.create({
            ...option,
            isSelectable: option.unavailable && option.isSelectable === undefined
                ? true
                : option.isSelectable,
            render: () => (React.createElement(DropdownOption, { className: classes.option, ...option, isFocused: focusedOptionId === option.id, descendantId: createOptionId(containerId, option.id) })),
        }));
    const open = () => {
        setIsExpanded(true);
    };
    const close = () => {
        setIsExpanded(false);
    };
    const onExpandedChange = (newExpanded) => {
        newExpanded ? open() : close();
    };
    const { handleKeydown } = useComboboxPatternKeys(options, onSelect, isExpanded, onExpandedChange, focusedOptionId, setFocusedOptionId);
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'data-hook': dataHook, disabled, forceContentElementVisibility, label, placeholder, value, name, id, placement, appendTo, displayBlock, dynamicWidth, className, } = props;
    const popoverPlacement = placement
        ? placement
        : removeElementMinWidth
            ? 'bottom-start'
            : 'bottom';
    const descendant = focusedOptionId && createOptionId(containerId, focusedOptionId);
    const baseElement = (React.createElement(FloatingDropdownBase, { className: classes.floatingDropdownBase, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, disabled: disabled, label: label, placeholder: placeholder, value: value, name: name, mobile: mobile, options: modifyOptions(options), id: id, "aria-activedescendant": isExpanded ? descendant : null, isExpanded: isExpanded, onChange: onSelect, displayBlock: displayBlock, "aria-controls": containerId }));
    return (React.createElement("div", { "data-mobile": mobile, "data-hook": dataHook, className: st(classes.root, { mobile, removeElementMinWidth }, classnames(classes.overrideStyleParams, className, {
            [classes.displayInline]: !displayBlock,
        })), ref: rootRef, onKeyDown: handleKeydown }, mobile ? (baseElement) : (React.createElement(CoreDropdown, { className: classes.dropdown, contentClassName: dropdownClasses.dropdownContainer, "data-hook": DATA_HOOKS.coreDropdown, "data-mobile": mobile, forceContentElementVisibility: forceContentElementVisibility, initialSelectedIds: value ? [value] : [], onInitialSelectedOptionsSet: () => { }, onDeselect: onCoreSelect, onSelect: onCoreSelect, openTrigger: "click", disabled: disabled, options: coreOptions, placement: popoverPlacement, onExpandedChange: onExpandedChange, appendTo: appendTo, dynamicWidth: dynamicWidth || appendTo === 'window', contentId: containerId, dropdownA11yFixes: true, preventContentKeydown: true }, baseElement))));
};
//# sourceMappingURL=FloatingDropdown.js.map